module.exports = __webpack_public_path__ + "a8639dec5833a8375d22fe425b01f4eb.woff";